/** Readout formatting. The TV has no settings of its own; it shows the
 * imperial units the phone publishes in. */
export function formatDistance(feet: number, digits = 1): string {
  return `${feet.toFixed(digits)} FT`;
}

export function formatSpeed(speedMps: number): string {
  return `${(speedMps * 2.23694).toFixed(1)} MPH`;
}

/** The readout speed for a putt event: ball speed off the face when the phone
 * sent it, else the gate read (older phones). */
export function readoutSpeedMps(event: { speedMps: number; ballSpeedMps?: number }): number {
  const b = event.ballSpeedMps;
  return typeof b === 'number' && Number.isFinite(b) && b > 0 ? b : event.speedMps;
}

/**
 * One putt's LEAVE (proximity). Under one foot it reads in whole inches
 * ("7 IN"), as the phone's proximity popup and putt cards do (the app's
 * utils/leaveDisplay.ts; Cole, 2026-10-04). Averages, totals, and boards keep
 * feet with one decimal (formatDistance).
 */
export function formatLeave(feet: number): string {
  const magnitude = Math.abs(feet);
  if (magnitude < 1) {
    // A real miss never reads "0 IN"; 11.5 in and up reads "12 IN".
    const inches = magnitude > 0 ? Math.max(1, Math.round(magnitude * 12)) : 0;
    return `${inches} IN`;
  }
  return `${magnitude.toFixed(1)} FT`;
}
